'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/pow.js
// module id = 2373
// module chunks = 1